var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"colorDominant colorAppBar",attrs:{"app":"","clipped-left":""}},[_c('img',{staticClass:"mr-1",style:({
      'max-width': _vm.$vuetify.breakpoint.smAndDown ? '100px' : '200px',
      'max-height': '48px',
    }),attrs:{"aspect-ratio":"1.0","src":_vm.$operatorLogoUrl(_vm.domain),"alt":_vm.domain}}),(this.$route.path === `/page/login/auth/${_vm.domain}`)?_c('v-spacer'):_vm._e(),(!_vm.$vuetify.breakpoint.xsOnly)?[_c('ButtonLanguages')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }